import src from "IMAGE";
export default { src, width: 816, height: 816, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAP0lEQVR42o2OUQYAQAhEu/95a4nSmpiP/akdHiMvJapWE8JidsrdG/RHwCAzi0Gn1AK2kIhoEMz+hfXE+uTEBZC2+U32JJW9AAAAAElFTkSuQmCC"};
